document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[id^="CustomisationToggle-"]').forEach(function (checkbox) {
    checkbox.addEventListener('change', function () {
      const sectionId = checkbox.id.replace('CustomisationToggle-', '');
      const textareaWrap = document.getElementById('CustomisationTextarea-' + sectionId);

      if (!textareaWrap) return;

      if (checkbox.checked) {
        textareaWrap.classList.add('is-open');
      } else {
        textareaWrap.classList.remove('is-open');

        const textarea = textareaWrap.querySelector('textarea');
        if (textarea) textarea.value = '';
      }
    });
  });
});